import L from "leaflet";
import "leaflet/dist/leaflet.css";

const mapData = document.querySelector("#map-wrapper");
const map = L.map('map-wrapper', {
    attributionControl: false,
    scrollWheelZoom: false
}).setView([mapData.dataset.lat, mapData.dataset.lng], 20);

// L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
L.tileLayer('//maps01.a-cdn.net/tiles/spitogatos/{z}/{x}/{y}.png?language=en&scale=1').addTo(map);

const svgIcon = L.divIcon({
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
<g class="map-marker" clip-path="url(#clip0_1841_3370)">
<path d="M35.5351 15.535C35.5351 27.9745 21.492 39.4952 21.492 39.4952C20.6715 40.1684 19.3286 40.1684 18.508 39.4952C18.508 39.4952 4.46494 27.9745 4.46494 15.535C4.46509 6.95525 11.4203 0 20 0C28.5798 0 35.5351 6.95525 35.5351 15.535Z" fill="var(--surface-color-700)"/>
<path d="M20 23.3508C15.6903 23.3508 12.1843 19.8446 12.1843 15.5351C12.1843 11.2256 15.6905 7.71923 20 7.71923C24.3096 7.71923 27.8158 11.2254 27.8158 15.535C27.8158 19.8445 24.3097 23.3508 20 23.3508Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_1841_3370">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>`,
    className: "svg-icon map-marker",
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40]
});

if(mapData) {
    const marker = L.marker([mapData.dataset.lat, mapData.dataset.lng], {icon: svgIcon}).addTo(map).bindPopup(mapData.dataset.content);
}